<script>
  import { onMount, onDestroy } from "svelte"
	import * as L from "leaflet"
  import {getMap} from "../map"

  const options = {
    position: "bottomright",
    showUnitControl: true
  }

  function setupMap() {
    const map = getMap()
    L.control.polylineMeasure(options).addTo(map);
    
  }
  
</script>
<svelte:head>
  <link rel='stylesheet' href='/Leaflet.PolylineMeasure.css' />
  <script src="/Leaflet.PolylineMeasure.js" on:load={setupMap}></script>
</svelte:head>